<template>
	<div>
    <el-form ref="colForm" :rules="rules" label-width="100px" class="demo-dynamic">
      <el-form-item label="关联功能">
        <el-select v-model="handleIds" multiple placeholder="请选择关联功能" @change="selectHandle">
          <el-option v-for="item in selection" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="显示序号">
        <el-radio-group v-model="listConfigObj.is_serial">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分页条数" class="w-300">
        <el-input v-model="listConfigObj.pagination"></el-input>
      </el-form-item>
      <el-form-item label="冻结列配置（固定前几列）" class="w-300">
        <el-input v-model="listConfigObj.freeze_column"></el-input>
      </el-form-item>
    </el-form>
    <div class="m-t-10">
      <el-table
        :data="listConfigObj.data_sort"
        border
        style="width: 100%">
        <el-table-column
          label="关键字"
          width="80">
          <template scope="scope">
            第{{ scope.$index + 1 }}级
          </template>
        </el-table-column>
        <el-table-column
          label="字段">
          <template scope="scope">
            <el-select v-model="scope.row.field_id" size="small">
              <el-option 
                v-for="item in listConfigObj.fields"
                :label="item.title"
                :value="item.field_id">
                <span>{{ item.field }}（{{ item.title }}）</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="排序">
          <template scope="scope">
            <el-select v-model="scope.row.sort" size="small">
              <el-option label="升序" value="asc"></el-option>
              <el-option label="降序" value="desc"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="70">
          <template scope="scope">
            <el-button type="text" size="small" @click="deleteSort(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="m-t-10 block">
        <el-button type="info" @click="addSort()">新增排序条件</el-button>
      </div>
    </div>

    <div class="m-t-20">
      <div class="m-b-10 fz-14">行数据样式变化配置</div>
      <el-table
        :data="listConfigObj.row_stylesheet"
        border
        style="width: 100%">
        <el-table-column
          label="优先度"
          width="120">
          <template scope="scope">
            <el-button v-if="scope.$index != 0" size="mini" @click="moveTr(scope.$index, 0)">上移</el-button>
            <el-button v-if="scope.$index != listConfigObj.row_stylesheet.length - 1" size="mini" @click="moveTr(scope.$index, 1)">下移</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="条件配置"
          width="120">
          <template scope="scope">
            <el-button type="text" size="small" @click="openSheetCondition(scope.$index)">配置</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="样式"
          width="140">
          <template scope="scope">
            <el-select v-model="scope.row.stylesheet" size="small">
              <el-option label="蓝底黑字" value="10"></el-option>
              <el-option label="蓝底红字" value="20"></el-option>
              <el-option label="红底白字" value="30"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="70">
          <template scope="scope">
            <el-button type="text" size="small" @click="deleteStyle(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="m-t-10 block">
        <el-button type="info" @click="addStyle()">新增样式配置</el-button>
      </div>
    </div>
    <sheet-config 
      ref="sheet" 
      :curConfig="curConfig"
      :index="index"
      :fields="listConfigObj.fields"
      @setCurConfig="setCurConfig">
    </sheet-config>
  </div>
</template>
<script>
import cmsConfig from '../../../config/cmsConfig'
import sheetConfig from './sheetConfig.vue'
export default {
  name: 'sortConfig',
  props: {
    application: {
      type: Array,
      default() {
        return []
      }
    },
    listIndex: {
      type: Number,
      default() {
        return -1
      }
    },
    listConfigObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      pagination: '',
      listChange: false,
      curConfig: [],
      selectedOperation: [],
      keywordObj: {
        field_id: '',
        sort: 'desc'
      },
      index: 0,
      styleObj: {
        logic_condition: [],
        stylesheet: ''
      },
      selection: [],
      handleIds: []
    }
  },
  methods: {
    openSheetCondition(index) {
      this.index = index
      this.curConfig = this.listConfigObj.row_stylesheet[index]['logic_condition']
      this.$refs.sheet.open()
    },
    setCurConfig(index, form) {
      this.listConfigObj.row_stylesheet[index]['logic_condition'] = form
    },
    exchangePosition(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    moveTr(index_, type) {
      let arr = []
      if (type) {
        // 下移
        arr = this.exchangePosition(this.listConfigObj.row_stylesheet, index_, index_ + 1)
      } else {
        // 上移
        arr = this.exchangePosition(this.listConfigObj.row_stylesheet, index_, index_ - 1)
      }
      this.listConfigObj.row_stylesheet = arr
    },
    addSort() {
      let newKey = _.cloneDeep(this.keywordObj)
      this.listConfigObj.data_sort.push(newKey)
    },
    deleteSort(item, index) {
      this.listConfigObj.data_sort.splice(index, 1)
    },
    addStyle() {
      let newStyle = _.cloneDeep(this.styleObj)
      this.listConfigObj.row_stylesheet.push(newStyle)
    },
    deleteStyle(item, index) {
      this.listConfigObj.row_stylesheet.splice(index, 1)
    },
    filterApplication() {
      let arr = []
      _(this.application).forEach((res) => {
        if (res.type != this.OPERATION_LIST && res.type != this.OPERATION_CHART) {
          let obj = {
            id: res.id,
            iden: res.iden,
            model_id: res.model_id,
            name: res.name,
            type: res.type
          }
          arr.push(obj)
        }
      })
      return arr
    },
    getHandleIds() {
      let arr = []
      _(this.listConfigObj.inner_handle).forEach((res) => {
        arr.push(res.id)
      })
      return arr
    },
    selectHandle(ids) {
      if (this.listChange) {
        return
      }
      let arr = []
      _(ids).forEach((id) => {
        _(this.selection).forEach((item) => {
          if (item.id == id) {
            arr.push(item)
            return
          }
        })
      })
      // _(this.selection).forEach((res) => {
      //   if (ids.indexOf(res.id) > -1) {
      //     arr.push(res)
      //   }
      // })
      this.listConfigObj.inner_handle = arr
    }
  },
  created() {
    this.selection = this.filterApplication()
    this.handleIds = this.getHandleIds()
  },
  watch: {
    'listIndex'() {
      this.listChange = true
      this.handleIds = this.getHandleIds()
    }
  },
  components: {
    sheetConfig
  },
  mixins: [cmsConfig]
}
</script>


// WEBPACK FOOTER //
// sortConfig.vue?2dbf2676